export type ImportType = "mealsMenu" | "payments" | "children";

type AsyncImportState = {
  importInProgress: boolean;
  importType: ImportType | null;
  importLabel: string | null;
};

const store = {
  namespaced: true,

  state: (): AsyncImportState => ({
    importInProgress: false,
    importType: null,
    importLabel: null,
  }),

  getters: {
    isImportInProgress: (state: AsyncImportState) => state.importInProgress,
    importType: (state: AsyncImportState) => state.importType,
    importLabel: (state: AsyncImportState) => state.importLabel,
  },

  mutations: {
    startImport(state: AsyncImportState, payload: { type: ImportType; label?: string }) {
      state.importInProgress = true;
      state.importType = payload.type;
      state.importLabel = payload.label ?? null;
    },
    finishImport(state: AsyncImportState) {
      state.importInProgress = false;
      state.importType = null;
      state.importLabel = null;
    },
    resetState(state: AsyncImportState) {
      state.importInProgress = false;
      state.importType = null;
      state.importLabel = null;
    },
  },
};

export default store;
